import { render, staticRenderFns } from "./MButton.vue?vue&type=template&id=451888db"
import script from "./MButton.vue?vue&type=script&lang=js"
export * from "./MButton.vue?vue&type=script&lang=js"
import style0 from "./MButton.vue?vue&type=style&index=0&id=451888db&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports